var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"f-700 f-28 m-b-30"},[_vm._v(" "+_vm._s(_vm._f("translate")('NOT_FOUND'))+" ")]),_c('button',{staticClass:"btn btn-primary m-a m-t-32",on:{"click":function($event){return _vm.$router.push({ name: 'FrontPage' })}}},[_vm._v(_vm._s(_vm._f("translate")('GO_TO_HOME')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }